export default __webpack_public_path__ + "static/media/blank.44a8a58d.jpg";